export const urls = {
  GET_LOKACIJE: 'Lokacije/vrati_lokacije_za_kupca',
  GET_KUPCE: 'Combo/vrati_kupce_combo',
  INSERT_LOKACIJE: 'Lokacije/unos_lokacije',
  UPDATE_LOKACIJE: 'Lokacije/izmena_lokacije',
  DELETE_LOKACIJE: 'Lokacije/brisanje_lokacije',
};
